import type { ComponentPropsWithoutRef } from 'react';
import type { AvatarData } from '@/api';
import { cn } from '@/utils';
import { DEFAULT_AVATAR_IMAGE } from '../constants/avatar.constants';
import { UserAvatar } from './UserAvatar';
const PROFILE_SIZE = 'size-[96px]';
interface ProfileAvatarProps extends ComponentPropsWithoutRef<'div'> {
  avatarData?: AvatarData | null;
}

/** 96px sprite-only avatar for profile pages. Wraps UserAvatar. */
export const ProfileAvatar = ({
  avatarData,
  className,
  ...props
}: ProfileAvatarProps) => {
  if (!avatarData) {
    return <div className={cn('relative inline-flex aspect-square shrink-0 overflow-hidden rounded-full', PROFILE_SIZE, className)} {...props}>
        <img src={DEFAULT_AVATAR_IMAGE} alt="" className="size-full object-cover" />
      </div>;
  }
  return <UserAvatar avatarData={avatarData} useSprite spritePixelSize={96} className={className} {...props} data-sentry-element="UserAvatar" data-sentry-component="ProfileAvatar" data-sentry-source-file="ProfileAvatar.tsx" />;
};